<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('manage.products')">Products</inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            {{ product.item_code }}
        </h1>
        <trashed-message v-if="product.deleted_at" class="mb-6" @restore="restore">
            This product has been deleted.
        </trashed-message>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div class="bg-white rounded shadow overflow-hidden">
            <form @submit.prevent="submit">
              <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                <text-input v-model="form.description" :errors="$page.props.errors.description" class="pr-6 pb-8 w-full lg:w-1/2" label="Description" />
                <select-input v-model="form.default_wcode" :errors="$page.props.errors.default_wcode" class="pr-6 pb-8 w-full lg:w-1/2" label="Default Warehouse">
                  <option :value="null"></option>
                  <option v-for="(warehouse, wcode) in attached_warehouses" :value="wcode" :key="wcode">{{ warehouse }}</option>
                </select-input>

                <select-input v-model="form.category_id" :errors="$page.props.errors.category_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Product Category">
                  <option :value="null" />
                  <option v-for="sub in categories" :value="sub.id" :key="sub.id">
                    {{ sub.name }}
                  </option>

                </select-input>


                <select-input v-model="form.product_tag_id" :errors="$page.props.errors.product_tag_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Product Tag">
                  <option :value="null" />
                  <option v-for="tag in tags" :value="tag.id" :key="tag.id">
                    {{ tag.label }}
                  </option>

                </select-input>

                <text-input v-model="form.min_order_quantity" :errors="$page.props.errors.min_order_quantity" class="pr-6 pb-8 w-full lg:w-1/2" label="Min Order Quantity" />
                <text-input v-model="form.max_order_quantity" :errors="$page.props.errors.max_order_quantity" class="pr-6 pb-8 w-full lg:w-1/2" label="Max Order Quantity" />

                <text-input v-model="form.desc_sort" :errors="$page.props.errors.desc_sort" type="number" class="pr-6 pb-8 w-full lg:w-1/2" label="Sort Order (Desc 100 - 0)" />

                <div class="pr-6 pb-8 w-full lg:w-1/2">
                  <div v-if='productImage' class="border bg-contain bg-no-repeat bg-bottom h-32 bg-white block mt-2" :style="`background-image: url(${product.image});`"></div>
                  <file-input  :errors="$page.props.errors.image" v-model="form.image" help="image max dimension 600px x 600px, max file size 600kb"></file-input>
                  <loading-button v-if="form.image" :loading="sending" class="mt-2 bg-green-500 text-white font-bold rounded text-xs btn-sm p-2" @click.prevent="uploadImage">Upload Image</loading-button>
                </div>

                <div class="pb-8">
                  <input type="checkbox" class="form-check" v-model="form.active"> Active
                </div>


              </div>
              <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex flex-wrap flex-col lg:flex-row-reverse">
                <loading-button :loading="sending" class="btn-primary mb-2 ml-2" type="submit">Update product</loading-button>
                <button class="btn-gray mb-2 ml-2" @click="openWarehouseModal" type="button">Attach Warehouse</button>
                <button v-if="!product.deleted_at" class="mb-2 ml-2 text-red-600 hover:underline lg:mr-auto" tabindex="-1" type="button" @click="destroy">Delete product</button>
              </div>
            </form>
          </div>
          <div v-show="offers.length > 0">
            <h2 class="font-bold text-2xl">Applied Special Offers</h2>
            <div class=" py-8 px-5">
              <ul>
                <li v-for="offer in offers" class="bg-white rounded px-3 py-2 mb-1">
                  <InertiaLink :href="route('manage.offers.edit', offer.id)">
                    <div class="flex">
                      <div>
                        <div>
                          {{ offer.title }}
                        </div>
                        <div class="text-sm text-gray-600 flex items-center justify-start gap-4 py-1">
                          <div>start date {{ offer.start_date | localDate }}</div>
                          <div>
                            <span v-if="offer.active" class="px-2 bg-green-200 rounded text-green-700">Active</span>
                            <span v-else class="px-2 bg-red-200 text-red-800 rounded">Inactive</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex-grow flex justify-end items-center">
                        <Icon name="cheveron-right" class="h-5 w-5" />
                      </div>
                    </div>
                  </InertiaLink>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <h2 class="font-bold text-2xl">Attached Warehouses</h2>
            <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
              <div class="bg-white flex flex-col overflow-hidden shadow rounded-lg" v-for="(whouse, wcode) in attached_items" :key="wcode" >
                <div class="p-6 flex-grow">
                  <dl>
                    <dd class="mt-1 text-base leading-tight font-semibold text-gray-900 flex flex-row">
                      <div class="text-xs px-1 py-1 rounded text-white bg-gray-400 mr-1">{{ wcode }}</div>
                      <div>{{ whouse }}</div>
                    </dd>
                    <dd v-if="inventory[wcode]" class="mt-2">
                      <div class="text-gray-400 text-xs">AVAILABLE QTY </div>
                      <div class="text-gray-600">{{ inventory[wcode].qty }}</div>
                    </dd>
                  </dl>
                </div>
                <div class="mt-4 bg-gray-100 text-right">
                  <button class="btn text-red-700 mb-2 ml-2 text-xs mx-4" @click="() => detachWarehouse(wcode)" type="button">remove</button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <modal size="md" :show="showModal" @closeModal="showModal = false">
            <form @submit.prevent="attachWarehouseSubmit" class="flex">
                <select-input v-model="form_attach.code" class="pr-6 w-full lg:w-1/2" label="Choose Warehouse">
                    <option :value="null" />
                    <option v-for="warehouse in warehousesComputed" :value="warehouse.code">{{ warehouse.code }} - {{ warehouse.name }}</option>
                </select-input>
                <div class="flex flex-row">
                    <button class="self-end btn-gray ml-2" type="submit">Attach</button>
                </div>
            </form>
        </modal>
    </div>
</template>

<script>
  import Modal from '@/Shared/Modal'
  import Icon from '@/Shared/Icon'
  import Layout from '@/Shared/Admin/Layout'
  import LoadingButton from '@/Shared/LoadingButton'
  import SelectInput from '@/Shared/SelectInput'
  import TextInput from '@/Shared/TextInput'
  import TrashedMessage from '@/Shared/TrashedMessage'
  import Toggle from '@/Shared/Toggle'
  import FileInput from '@/Shared/FileInput'

  export default {
    metaInfo() {
      return { title: this.form.name }
    },
    layout: Layout,
    components: {
      Modal,
      Icon,
      LoadingButton,
      SelectInput,
      TextInput,
      TrashedMessage,
      Toggle,
      FileInput
    },
    props: {
      product: Object,
      categories: Array,
      tags: Array,
      attached_warehouses: Object,
      warehouses: Array,
      inventory: Object,
      offers: Array
    },
    remember: 'form',
    data() {

      return {
        imageData: '',
        showModal:false,
        sending: false,
        productImage: this.product.image,
        form: this.$inertia.form({
          description: this.product.description,
          category_id: this.product.category_id,
          product_tag_id: this.product.product_tag_id,
          min_order_quantity: this.product.min_order_quantity,
          max_order_quantity: this.product.max_order_quantity,
          default_wcode: this.product.default_wcode,
          desc_sort: this.product.desc_sort,
          active: this.product.active
        }),
        form_attach: {
          code: null
        },
        attached_items: this.attached_warehouses
      }
    },

    computed: {
      warehousesComputed() {
        return this.warehouses.filter(item => {
          if(this.attached_items[item.code]) {
            return false;
          }
          return true;
        })
      }
    },
    methods: {
      submit() {
        this.sending = true
        this.form.put(this.route('manage.products.update', this.product.id), {
          onSuccess: () => {
            this.productImage = this.product.image
          },
          onFinish: () => {
            this.sending = false

          }})
      },

      uploadImage() {

        if(this.form.image) {
          this.sending = true;
          let formData = new FormData();
          this.productImage = null;
          formData.append('image', this.form.image);

          this.$inertia.post(this.route('manage.products.image-update', this.product.id), formData, {
            onFinish: () => {
              this.sending = false
            },
            onSuccess: () => {
              this.productImage = this.product.image
            }})
        }

      },

      previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
          // create a new FileReader to read this image and convert to base64 format
          var reader = new FileReader();
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = (e) => {
            // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
            // Read image as base64 and set to imageData
            this.imageData = e.target.result;
          }
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(input.files[0]);
        }
      },

      attachWarehouseSubmit() {
        this.sending = true
        this.$http.post(this.route('ajax.products.attach_warehouse', this.product.id), this.form_attach)
          .then((response) => {
            this.sending = false
            this.attached_items = response.data
            this.showModal = false;
            this.form_attach.code = null;
            this.form.image = null;
          })
      },
      detachWarehouse(wcode) {
        this.sending = true
        this.$http.post(this.route('ajax.products.detach_warehouse', this.product.id), {
          code : wcode
        })
          .then((response) => {
            this.sending = false
            this.attached_items = response.data;
          })
      },
      destroy() {
        if (confirm('Are you sure you want to delete this product?')) {
          this.$inertia.delete(this.route('manage.products.destroy', this.product.id))
        }
      },
      openWarehouseModal() {
        this.showModal = true;

      },
    },
  }
</script>
